export const DEFAULT_FILTER_VALUE = "-1";
